// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__18bPl","col":"styles_col__2j9Dl","fulfillmentStatus":"styles_fulfillmentStatus__1TjWW","emailCol":"styles_emailCol__3sT7R"};